export enum FileTag {
  None = '',
  TagPhoto = 'tag_photo',
  InstructionPhoto = 'instruction_photo',
  JobPhoto = 'job_photo',
}

export enum FileType {
  Document = 'document',
  Image = 'image',
  Other = 'other',
  Preview = 'preview',
  Video = 'video',
}

export interface FileMetadata {
  fileKey?: string;
  createdByUserID: number;
  tenantID: number;
  entityType: string;
  entityID?: number;
  fileType: FileType;
  location?: Location;
  uploadFileURL?: string;
  downloadFileURL?: string;
  created?: Date;
  errorMsg?: string;
  data: FileData;
}

export interface FileUpload extends File {
  preview: string;
  metadata: FileMetadata;
  uploaded: boolean;
  base64?: string;
}

export interface FileLink {
  fileKey: string;
  url: string;
  previewUrl?: string;
  fileType: FileType;
  title: string;
}

export interface FileData {
  title: string;
  description: string;
  permanent?: boolean;
  content?: string;
  fileTag?: FileTag;
}
